import { g as generateUUID } from './misc-9fdbcfbb.js';

var __rest = (undefined && undefined.__rest) || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
    t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
/**
 * The dialog controller
 */
class VegaDialogController {
  /**
   * It creates a new `vega-dialog` element, sets its properties, appends it to the DOM, and opens it
   *
   * @param {VegaDialogOption} options - VegaDialogOption
   * @returns {HTMLElement} The dialog reference.
   */
  open(options) {
    const dialog = document.createElement('vega-dialog');
    const { isVerticallyCenter, showCloseButton, size, title } = options, dialogProps = __rest(options, ["isVerticallyCenter", "showCloseButton", "size", "title"]);
    dialog.id = `vega-dialog-${generateUUID()}`;
    dialog.dialogTitle = title;
    dialog.modalProps = { isVerticallyCenter, showCloseButton, size };
    Object.keys(dialogProps).forEach((propName) => {
      if (dialogProps[propName] !== undefined) {
        dialog[propName] = dialogProps[propName];
      }
    });
    document.body.append(dialog);
    return dialog;
  }
}
const VegaDialog = new VegaDialogController();

export { VegaDialog as V };
